import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  inject,
} from '@angular/core';
import tippy, { Instance, Placement, Props } from 'tippy.js';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[tippy]',
})
export class TippyDirective implements OnChanges, OnDestroy {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input() tippy: string | null | undefined;
  @Input() tippyDisabled: string | boolean | null | undefined;
  /**
   * 'top' | 'top-start' | 'top-end' |
   * 'right' | 'right-start' | 'right-end' |
   * 'bottom' | 'bottom-start' | 'bottom-end' |
   * 'left' | 'left-start' | 'left-end' |
   * 'auto' | 'auto-start' | 'auto-end'
   */
  @Input() tippyPlacement: string | null | undefined;
  @Input() tippyShowDelay: string | number | null | undefined;
  @Input() tippyHtml = false;
  @Input() tippyMaxWidth: string | number | undefined;

  private tooltip!: Instance<Props>;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tooltip == null) {
      this.tooltip = tippy(this.elementRef.nativeElement, {
        animation: 'scale-subtle',
        duration: [100, 50],
        // placement: 'bottom'
      });
    }

    if (changes['tippy'] != null) {
      this.tooltip.setContent(this.tippy!);
    }

    if (changes['tippyDisabled'] != null) {
      if (this.tippyDisabled) {
        this.tooltip.disable();
      } else {
        this.tooltip.enable();
      }
    }

    if (changes['tippyPlacement'] != null) {
      this.tooltip.setProps({ placement: this.tippyPlacement as Placement });
    }

    if (changes['tippyShowDelay'] != null) {
      const showDelay =
        typeof this.tippyShowDelay === 'number'
          ? this.tippyShowDelay
          : parseInt(this.tippyShowDelay!, 10);
      this.tooltip.setProps({ delay: [showDelay, null] });
    }

    if (changes['tippyHtml'] != null) {
      this.tooltip.setProps({ allowHTML: this.tippyHtml });
    }

    if (changes['tippyMaxWidth']) {
      this.tooltip.setProps({ maxWidth: this.tippyMaxWidth });
    }
  }

  ngOnDestroy() {
    this.tooltip?.destroy();
  }
}
